export const CONFIRM_IMPORT = 'socrates-online/schemeImport/CONFIRM_IMPORT';
export const CLEAR_SCHEMES = 'socrates-online/schemeImport/CLEAR_SCHEMES';
export const IS_IMPORTED = 'socrates-online/schemeImport/IS_IMPORTED';
export const IS_LOADING = 'socrates-online/schemeImport/IS_LOADING';
export const IMPORTED_ERROR = 'socrates-online/schemeImport/IMPORTED_ERROR';

export const initialState = {
  isLoading: false,
  isPopulated: false,
  isImported: false,
  isError: false,
  schemes: [],
  schemeGroups: [],
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CONFIRM_IMPORT:
      return {
        ...state,
        isPopulated: true,
        isLoading: false,
        schemes: action.data.schemes,
        schemeGroups: action.data.schemeGroups,
      };
    case CLEAR_SCHEMES:
      return {
        ...state,
        isLoading: false,
        isPopulated: false,
        isImported: false,
        isError: false,
        schemes: [],
        schemeGroups: [],
      };
    case IS_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case IS_IMPORTED:
      return {
        ...state,
        isImported: action.status,
        isError: false,
      };
    case IMPORTED_ERROR:
      return {
        isError: true,
        isLoading: false,
        isImported: false,
        schemes: [],
        schemeGroups: [],
      };
    default:
      return state;
  }
}
